var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3603 29.4374C27.0709 29.4374 30.079 26.4293 30.079 22.7187C30.079 19.0081 27.0709 16 23.3603 16C19.6497 16 16.6416 19.0081 16.6416 22.7187C16.6416 26.4293 19.6497 29.4374 23.3603 29.4374Z",
    fill: "#121533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6412 13.1163C16.2631 13.1163 19.1993 10.1801 19.1993 6.55815C19.1993 2.93618 16.2631 0 12.6412 0C9.01919 0 6.08301 2.93618 6.08301 6.55815C6.08301 10.1801 9.01919 13.1163 12.6412 13.1163Z",
    fill: "#304CD0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47708 31.9932C6.9497 31.9932 8.95416 29.9888 8.95416 27.5161C8.95416 25.0435 6.9497 23.0391 4.47708 23.0391C2.00446 23.0391 0 25.0435 0 27.5161C0 29.9888 2.00446 31.9932 4.47708 31.9932Z",
    fill: "#97A5E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5996 46.7168C20.6043 46.7168 23.04 44.281 23.04 41.2764C23.04 38.2717 20.6043 35.8359 17.5996 35.8359C14.5949 35.8359 12.1592 38.2717 12.1592 41.2764C12.1592 44.281 14.5949 46.7168 17.5996 46.7168Z",
    fill: "#304CD0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3178 16.0008C44.5605 16.0008 47.9998 12.5614 47.9998 8.31877C47.9998 4.07609 44.5605 0.636719 40.3178 0.636719C36.0751 0.636719 32.6357 4.07609 32.6357 8.31877C32.6357 12.5614 36.0751 16.0008 40.3178 16.0008Z",
    fill: "#CBD2F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7193 42.2375C42.7847 42.2375 46.0803 38.9419 46.0803 34.8766C46.0803 30.8112 42.7847 27.5156 38.7193 27.5156C34.654 27.5156 31.3584 30.8112 31.3584 34.8766C31.3584 38.9419 34.654 42.2375 38.7193 42.2375Z",
    fill: "#6479DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.cd11c9c5a1eba1f7f66b32755781840d.svg";
export { ForwardRef as ReactComponent };